import { useState, useEffect } from "react";

export const useSiteEdit = ({
  site,
  createSite,
  updateSite,
  cancelEditing,
  close,
}) => {
  const [name, setName] = useState(site?.name);
  const [description, setDescription] = useState(site?.description);
  const [siteSubjects, setSiteSubjects] = useState(site?.Subjects || []);
  const [siteUsers, setSiteUsers] = useState(site?.Users || []);

  useEffect(() => {
    if (site) {
      setName(site.name || '');
      setDescription(site.description || '');
    }
  }, [site]); 

  const onReset = () => {
    setName(site?.name);
    setDescription(site.description || '');
  };

  const updateSubjects = (values) => {
    setSiteSubjects(values);
  };

  const updateUsers = (values) => {
    setSiteUsers(values);
  };

  const create = () => {
    if (!site.id) {
      createSite({
        id: site.id,
        name,
        description,
        subjects: siteSubjects,
        users: siteUsers,
      });
    } else {
      updateSite(site.id, {
        ...site,
        name,
        description,
        subjects: siteSubjects,
        users: siteUsers,
      });
    }
  };

  const cancel = () => {
    if (site?.id) {
      onReset();
      cancelEditing();
      return;
    }
    close();
  };
  return {
    save: create,
    cancel: cancel,
    id: site?.id,
    isActive: site.status === 'active',
    name: {
      value: name,
      update: (value) => setName(value.target.value),
    },
    description: {
      value: description,
      update: (value) => {
        setDescription(value.target.value);
      },
    },
    subjects: {
      value: siteSubjects,
      onChange: (values) => {
        updateSubjects(values);
      },
      onCreate: (values) => {
        updateSubjects(values);
      },
    },
    users: {
      value: siteUsers,
      onChange: (values) => {
        updateUsers(values);
      },
      onCreate: (values) => {
        updateUsers(values);
      },
    },
  };
};
